import * as states from './states';

export const NEW = states.NEW;
export const LOADING = states.LOADING;
export const OKAY = states.OKAY;
export const FAILED = states.FAILED;
export const CREATED = 'created';
